"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGInput = void 0;

var _react = _interopRequireDefault(require("react"));

require("./Input.scss");

var BHGInput = function BHGInput(props) {
  var type = props.type,
      value = props.value,
      className = props.className,
      error = props.error,
      placeholder = props.placeholder,
      onChange = props.onChange,
      disabled = props.disabled;
  return /*#__PURE__*/_react.default.createElement("input", Object.assign({
    type: type,
    className: "form-control" + (error ? " error " : " ") + (className ? className : ""),
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    disabled: disabled,
    "aria-disabled": disabled,
    autoComplete: "off"
  }, props));
};

exports.BHGInput = BHGInput;
BHGInput.defaultProps = {
  type: 'text',
  disabled: false,
  value: '',
  error: false,
  placeholder: '',
  onChange: function onChange(e) {
    return console.log(e);
  }
};